import { makeAutoObservable, runInAction } from "mobx";
import ApiManager from "../helpers/ApiManager";

/**
 * Upload store for managing file uploads and session attachments
 * Handles file uploads for call notes and chat messages
 */
class uploadStore {

  /**
   * Initialize the upload store
   * Sets up MobX observables for reactive state management
   */
  constructor() {
    makeAutoObservable(this);
  }

  /** @type {Array} Array of files attached to session notes */
  sessionNotesFiles = [];

  /**
   * Set the session notes files array
   * @param {Array} files - Array of file objects
   * @returns {void}
   */
  setSessionNotesFiles(files) {
    this.sessionNotesFiles = files;
  }

  /**
   * Add a new file to session notes
   * Uses runInAction for MobX state updates
   * @param {Object} file - File object to add
   * @returns {void}
   */
  addSessionNotesFile(file) {
    const newFiles = [...this.sessionNotesFiles, file];

    runInAction(() => {
      this.setSessionNotesFiles(newFiles);
    });
  }

  /**
   * Upload file to call session notes
   * @async
   * @param {File} file - File object to upload
   * @param {string} slug - Call session identifier
   * @returns {Promise<Object>} API response with upload data
   */
  async uploadFileToCall(file, slug) {

    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('slug', slug);
      formData.append('type', 'note');

      const response = await ApiManager.uploadFile(`uploads/calls/${slug}/uploads`, formData);
      this.sessionNotesFiles.push(response.data);
      return response;
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message ? error.response.data.message : 'Something went wrong',
      };
    }

  }

  /**
   * Upload file to chat message
   * @async
   * @param {File} file - File object to upload
   * @param {string} slug - Call session identifier
   * @returns {Promise<Object>} API response with upload data
   */
  async uploadFileToChat(file, slug) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('slug', slug);
      formData.append('type', 'chat');
      const response = await ApiManager.uploadFile(`uploads/calls/${slug}/uploads`, formData);
      return response;
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message ? error.response.data.message : 'Something went wrong',
      };
    }
  }

}

const UploadStore = new uploadStore();
export default UploadStore;